module.exports = __webpack_public_path__ + "img/com.775cd018.png";